<mat-accordion>
  <mat-expansion-panel hideToggle="true" expanded="true" disabled="true">
    <mat-expansion-panel-header style="color:#ffffff;">{{ appStringAPI.getAppString('tennis.players.comments.label')| uppercase  }}</mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      @for (comment of match_comment; track comment) {
        <div class="match-comment">
          {{ comment.body }}
        </div>
      }
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
